export default __webpack_public_path__ + "static/media/recommend.18b69e7b.jpg";